import * as React from 'react'

type EntryActionsProps = {
  actions: React.ReactNode[]
  containerClassName?: string
  columnClassName?: string
}

export default function EntryActions({
  actions,
  containerClassName = 'row edit-button',
  columnClassName = 'col-12',
}: EntryActionsProps) {
  if (!actions.length) return null

  return (
    <div className={containerClassName}>
      <div className={columnClassName}>
        {actions.map((action, index) => (
          <React.Fragment key={index}>{action}</React.Fragment>
        ))}
      </div>
    </div>
  )
}
